import { Share2 } from "lucide-react";
import { toast } from "sonner";

export default function Navbar() {
  const links = [
    ["Wish List", "#wishlist"],
    ["Gift Cards", "#giftcards"],
    ["Donate", "#donate"],
    ["Football", "#football"],
    ["Postcards", "#postcards"],
    ["The Wall", "#wall"],
    ["Calendar", "#calendar"],
  ];

  const share = async () => {
    const data = {
      title: "Chase Takes the Purple Turf",
      text: "Help send Chase off to Curry College football! Gifts, blessings, and words of encouragement 💜",
      url: window.location.origin,
    };
    try {
      if (navigator.share) {
        await navigator.share(data);
      } else {
        await navigator.clipboard.writeText(data.url);
        toast.success("Link copied — text it to friends & family!");
      }
    } catch (e) {
      if (e.name !== "AbortError") {
        try {
          await navigator.clipboard.writeText(data.url);
          toast.success("Link copied — text it to friends & family!");
        } catch {
          toast.error("Couldn't share — copy the address bar link");
        }
      }
    }
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-zinc-950/60 border-b border-white/10">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="font-display text-2xl tracking-tight text-white">CHASE</span>
          <span className="font-sub text-xs uppercase tracking-[0.25em] text-purple-400 mt-1">@ Curry '26</span>
        </a>
        <div className="hidden lg:flex items-center gap-6">
          {links.map(([label, href]) => (
            <a
              key={href}
              href={href}
              data-testid={`nav-link-${href.slice(1)}`}
              className="font-sub text-sm text-zinc-400 hover:text-white transition-colors duration-200"
            >
              {label}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={share}
            data-testid="share-site-btn"
            aria-label="Share this site"
            className="flex items-center gap-2 font-sub text-sm font-semibold border border-white/15 hover:border-purple-400 text-zinc-300 hover:text-white px-4 py-2 rounded-full transition-colors duration-200 active:scale-95"
          >
            <Share2 className="w-4 h-4" /> <span className="hidden sm:inline">Share</span>
          </button>
          <a
            href="#donate"
            data-testid="nav-donate-btn"
            className="font-sub text-sm font-semibold bg-purple-600 hover:bg-purple-500 text-white px-5 py-2 rounded-full transition-colors duration-200 drop-shadow-[0_0_15px_rgba(147,51,234,0.4)]"
          >
            Support Chase
          </a>
        </div>
      </nav>
    </header>
  );
}
